import { gql } from "@apollo/client";
import type { DspAdjustBillTask } from "./getDspAdjustBillTask";

export const GET_DSP_ADJUST_BILL_TASKS = gql`
  query GetDspAdjustBillTasks($billId: ID!) {
    getDspAdjustBillTasks(billId: $billId) {
      id
      billId
      successCount
      failCount
      progress
      createdAt
      finishedTime
      status
      processingStep
      errorMsg
    }
  }
`;

export interface GetDspAdjustBillTasksData {
  getDspAdjustBillTasks: DspAdjustBillTask[];
}

export interface GetDspAdjustBillTasksVariables {
  billId: string;
}
